var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("img", {
    staticClass: "VuetifyLogo",
    attrs: { alt: "Vuetify Logo", src: "/vuetify-logo.svg" },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }